import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function GarageFeature() {
  const specs = ['1,500 sq ft climate-controlled space', '14ft high clearance doors for RVs', '220V power & reinforced concrete', 'Separate office/studio potential', 'Drive-through capability', 'Built-in cabinetry & workbench'];
  return <section id="garage" className="py-20 bg-[#2D2D2D] text-white overflow-hidden" data-id="element-58">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-59">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-60">
          {/* Content Side */}
          <motion.div className="w-full lg:w-1/2" initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-61">
            <span className="text-[#C1694F] font-medium tracking-wider uppercase text-sm mb-2 block" data-id="element-62">
              The Crown Jewel
            </span>
            <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-63">
              Room to Live, <br data-id="element-64" />
              <span className="text-[#E8DCC4]" data-id="element-65">Work, and Play</span>
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-66">
              This isn't just a garage; it's a sanctuary for your passions.
              Whether you're a collector, a creator, or an adventurer, this
              detached workshop offers the professional-grade space you've been
              dreaming of.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-67">
              {specs.map((spec, index) => <div key={index} className="flex items-start" data-id="element-68">
                  <div className="mt-1 mr-3 bg-[#C1694F]/20 p-1 rounded-full" data-id="element-69">
                    <Check size={14} className="text-[#C1694F]" data-id="element-70" />
                  </div>
                  <span className="text-gray-300" data-id="element-71">{spec}</span>
                </div>)}
            </div>

            <Button variant="primary" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-72">
              See Floor Plan
            </Button>
          </motion.div>

          {/* Image Side */}
          <motion.div className="w-full lg:w-1/2 relative" initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-73">
            <div className="relative rounded-lg overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-74">
              <img src="https://storage.googleapis.com/stateless-vikingsteelstructure/2024/06/85646e6a-52x48x18-commercial-metal-building-768x431.webp" alt="Steel 3-Car Garage" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-75" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-8" data-id="element-76">
                <p className="text-white font-serif italic text-xl" data-id="element-77">
                  "Finally, enough space for everything."
                </p>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#C1694F] rounded-full opacity-20 blur-2xl" data-id="element-78"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#E8DCC4] rounded-full opacity-10 blur-3xl" data-id="element-79"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}